import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PRINCIPLES } from "@/content";

function PrincipleRow({ p, index }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start 90%", "end 30%"],
  });
  const numY = useTransform(scrollYProgress, [0, 1], [-32, 28]);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10%" }}
      transition={{ duration: 0.85, delay: index * 0.04, ease: [0.16, 1, 0.3, 1] }}
      className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline py-9 md:py-12 border-t border-black/10 transition-colors hover:bg-cta/[0.025]"
      data-testid={`principle-${p.n}`}
    >
      <motion.div style={{ y: numY }} className="col-span-2 md:col-span-1">
        <span className="font-mono text-[13px] md:text-[15px] tracking-[0.24em] text-mute group-hover:text-cta transition-colors">
          {p.n}
        </span>
      </motion.div>
      <div className="col-span-10 md:col-span-7">
        <h3 className="font-serif text-[28px] md:text-[44px] lg:text-[52px] leading-[1.05] tracking-tight text-ink group-hover:text-cta transition-colors">
          {p.title}
        </h3>
      </div>
      <p className="col-span-12 md:col-span-4 text-mute leading-[1.65] text-[14.5px] md:text-[15.5px] mt-2 md:mt-3">
        {p.desc}
      </p>
    </motion.div>
  );
}

export default function Operate() {
  return (
    <section id="operate" className="chapter py-24 md:py-36" data-testid="chapter-operate">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="mb-12 md:mb-20 max-w-[60ch]"
        >
          <div className="label-mono mb-5">04 — How I Operate</div>
          <h2 className="font-serif text-[44px] md:text-[72px] leading-[1.0] tracking-tight text-ink">
            Six principles,
            <br />
            <span className="italic text-mute">learned the expensive way.</span>
          </h2>
        </motion.div>

        <div>
          {PRINCIPLES.map((p, i) => (
            <PrincipleRow key={p.n} p={p} index={i} />
          ))}
          <div className="h-[1px] bg-black/10" />
        </div>
      </div>
    </section>
  );
}
